import { defaultHeight, defaultWidth, offset } from "../defaults.js";

const drawPartThread = (container, data) => {
  const bindingData = [data];
  const cline1 = container.selectAll("line.cline1").data(bindingData);
  cline1
    .enter()
    .append("line")
    .classed("cline1", true)
    .merge(cline1)
    .attr("x1", (d) =>
      d.index === 0 ? -offset : d.precedingPosition?.x - d.position.x + offset
    )
    .attr("x2", (d) => (!d.index || d.index === 0 ? 0 : 5))
    .attr("y1", 5)
    .attr("y2", 5);
  cline1.exit().remove();

  const cline3 = container.selectAll("line.cline3").data(bindingData);
  cline3
    .enter()
    .append("line")
    .classed("cline3", true)
    .merge(cline3)
    .attr("x1", defaultWidth / 2)
    .attr("y1", defaultHeight - 4)
    .attr("x2", defaultWidth / 2)
    .attr("y2", defaultHeight + 20);
  cline3.exit().remove();

  const ppoly = container.selectAll("polygon.ppoly").data(bindingData);
  ppoly
    .enter()
    .append("polygon")
    .classed("ppoly", true)
    .merge(ppoly)
    .attr(
      "points",
      `4,${defaultHeight - 9} ${defaultWidth / 2},-1 ${defaultWidth - 4}, ${defaultHeight - 9}`
    );
  ppoly.exit().remove();
};

const drawPartRepeatThread = (container, data, onDrag) => {
  drawPartThread(container, data);
  const bindingData = [data];
  drawAsterisk(container, data);

  const repeatLabel = container
    .selectAll("text.repeat-label")
    .data(bindingData);
  repeatLabel
    .enter()
    .append("text")
    .classed("repeat-label", true)
    .merge(repeatLabel)
    .attr("x", (d) => d.labelPosition?.x ?? defaultWidth / 2)
    .attr("y", (d) => d.labelPosition?.y ?? -5)
    .attr("dy", "0.35em")
    .attr("text-anchor", "middle")
    .text((d) => d.label || "repeat")
    .call(onDrag);

  repeatLabel.exit().remove();
};

const drawAsterisk = (part, data) => {
  const bindingData = [data];
  const asterisk = part.selectAll("text.asterisk").data(bindingData);
  asterisk
    .enter()
    .append("text")
    .classed("asterisk", true)
    .merge(asterisk)
    .attr("x", 4 + defaultWidth / 2)
    .attr("y", defaultHeight - 8)
    .attr("dy", "0.35em")
    .attr("font-size", "36px")
    .text("*");
  asterisk.exit().remove();

  return asterisk;
};

export { drawPartThread, drawPartRepeatThread };
